import * as React from 'react';

import { FieldArray } from 'react-final-form-arrays';
import { Field, AnyObject } from 'react-final-form';
import TagSelect from '../controls/forms/redesign/TagSelect';
import { SelectItem } from 'src/models/common/SelectItem';
import Tag from 'src/models/Tag';
import { FormApi } from 'final-form';

interface ITagContainerProps {
    label?: string;
    disabledMessage?: string;
    isDisabled?: boolean;
    selectTags: Array<SelectItem>;
    form?: FormApi;
    isTagCreatable?: boolean;
    fieldArrayName: string;
    fieldAddArrayName: string;
    fieldDeleteArrayName: string;
    initialValueName: string;
    className?: string;
    style?: React.CSSProperties;
}

type ITagContainerState = {
    focusClass?: string;
};

class TagContainer extends React.Component<ITagContainerProps, ITagContainerState> {
    private inputRef: React.RefObject<HTMLInputElement>;
    constructor(props: ITagContainerProps) {
        super(props);
        this.inputRef = React.createRef<HTMLInputElement>();

        this.state = {
            focusClass: this.shouldFocus() ? 'focused' : 'unfocused',
        };
    }

    public componentDidUpdate(prevProps: ITagContainerProps) {
        if (this.props.form && this.props.form !== prevProps.form) {
            this.setState({ focusClass: this.shouldFocus() ? 'focused' : 'unfocused' });
        }
    }
    shouldFocus = () => {
        if (!this.props.form) {
            return false;
        }
        const formValues: AnyObject = this.props.form.getState().values;
        if (formValues[this.props.fieldArrayName] && formValues[this.props.fieldArrayName].length > 0) {
            return true;
        } else if (formValues[this.props.fieldAddArrayName] && formValues[this.props.fieldAddArrayName].length > 0) {
            return true;
        } else {
            return false;
        }
    };

    onSelect = () => {
        if (!this.props.form) {
            return;
        }

        const formValues: AnyObject = this.props.form.getState().values;
        const newTag = new Tag();
        if (formValues[this.props.initialValueName]) {
            const temp = this.props.selectTags.find((x) => x.id === formValues[this.props.initialValueName]);
            newTag.id = temp.id as number;
            newTag.name = temp.name;
        }

        this.addTagToForm(newTag);
    };

    onTabKey = (tagId: number) => {
        if (!this.props.form) {
            return;
        }
        const newTag = new Tag();
        if (this.inputRef.current.value) {
            if (this.props.selectTags.some((x) => x.id === tagId)) {
                const temp = this.props.selectTags.find((x) => x.id === tagId);
                newTag.id = temp.id as number;
                newTag.name = temp.name;
            } else if (this.props.isTagCreatable) {
                newTag.name = this.inputRef.current.value;
            }
        }

        this.addTagToForm(newTag);
    };

    addTagToForm = (newTag: Tag) => {
        const formValues: AnyObject = this.props.form.getState().values;

        if (
            newTag.name &&
            newTag.name.trim().length > 0 &&
            (!formValues[this.props.fieldAddArrayName] ||
                !formValues[this.props.fieldAddArrayName].some((item: Tag) => item.name.trim().toLowerCase() === newTag.name.trim().toLowerCase())) &&
            (!formValues[this.props.fieldArrayName] ||
                !formValues[this.props.fieldArrayName].some((item: Tag) => item.name.trim().toLowerCase() === newTag.name.trim().toLowerCase()))
        ) {
            this.props.form.mutators.push(this.props.fieldAddArrayName, {
                id: newTag.id,
                name: newTag.name,
            });
        }

        this.props.form.change(this.props.initialValueName, undefined);
    };

    removeCurrentTag = (fields: AnyObject, index: number, selectedTag: AnyObject) => {
        if (selectedTag.name && (selectedTag.name as string).trim().length > 0) {
            this.props.form.mutators.push(this.props.fieldDeleteArrayName, { id: selectedTag.id, name: selectedTag.name });
        }
        fields.remove(index);
    };

    removeAdditionalTag = (index: number) => {
        this.props.form.mutators.remove(this.props.fieldAddArrayName, index);
    };

    handleClick = () => {
        if (!this.props.isDisabled) {
            this.setState({ focusClass: 'focused' });
            this.inputRef.current.focus();
        }
    };

    handleFocus = () => {
        if (!this.props.isDisabled) {
            this.setState({ focusClass: 'focused' });
        }
    };

    onBlur = () => {
        if (!this.shouldFocus()) {
            this.setState({ focusClass: 'unfocused' });
        }
    };

    render() {
        return (
            <>
                <div className={`dlc-form-tag-select-wrapper ${this.props.className || ''}`} style={this.props.style}>
                    <div
                        style={{ background: 'white', display: 'flex', flexWrap: 'wrap', padding: '11px' }}
                        onMouseUp={this.handleClick}
                        onFocus={this.handleFocus}
                    >
                        <FieldArray name={this.props.fieldArrayName}>
                            {({ fields }) => {
                                return fields.map((name, index) => (
                                    <Field key={index} name={`${name}`}>
                                        {({ input }) => (
                                            <span
                                                style={{
                                                    padding: '.6rem',
                                                    border: '1px solid #ccc',
                                                    background: 'white',
                                                    margin: '0px 1px',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                {input.value.name}
                                                <span
                                                    onClick={() => this.removeCurrentTag(fields, index, input.value)}
                                                    style={{ cursor: 'pointer', padding: '0 0 0 3px' }}
                                                >
                                                    <i className="fas fa-times-circle" />
                                                </span>
                                            </span>
                                        )}
                                    </Field>
                                ));
                            }}
                        </FieldArray>
                        <FieldArray name={this.props.fieldAddArrayName}>
                            {({ fields }) => {
                                return fields.map((name, index) => (
                                    <Field key={index} name={`${name}`}>
                                        {({ input }) => (
                                            <span
                                                style={{
                                                    padding: '.6rem',
                                                    border: '1px solid #ccc',
                                                    background: 'white',
                                                    margin: '0px 1px',
                                                    display: 'inline-block',
                                                }}
                                            >
                                                {input.value.name}
                                                <span
                                                    onClick={() => this.removeAdditionalTag(index)}
                                                    style={{ cursor: 'pointer', padding: '0 0 0 3px' }}
                                                >
                                                    &nbsp;
                                                    <i className="fas fa-times-circle" />
                                                </span>
                                            </span>
                                        )}
                                    </Field>
                                ));
                            }}
                        </FieldArray>
                        <TagSelect
                            isDisabled={this.props.isDisabled}
                            name={this.props.initialValueName}
                            items={this.props.selectTags}
                            onSelect={() => this.onSelect()}
                            onTabKey={(id: number) => this.onTabKey(id)}
                            blur={() => this.onBlur()}
                            inputRef={this.inputRef}
                        />
                    </div>
                    {!this.props.isDisabled && this.props.label && <div className={this.state.focusClass}>{this.props.label}</div>}
                    {this.props.isDisabled && <div className={this.state.focusClass}>{this.props.disabledMessage}</div>}
                </div>
            </>
        );
    }
}

export default TagContainer;



// WEBPACK FOOTER //
// ./src/components/counties/TagContainer.tsx